<template>
<div class="boxs">
  <div class="verification-container">
    <!-- <h2 class="verification-title">安全验证</h2> -->
    <p class="verification-desc">请拖动滑块到最右侧完成验证</p>

    <div
      class="slider-container"
      @mousedown="onSliderMouseDown"
      @touchstart="onSliderTouchStart"
    >
      <div class="slider-fill" :style="{ width: fillWidth + 'px' }"></div>
      <div class="slider-track">
        {{ sliderText }}
      </div>
      <div
        class="slider-thumb"
        :style="{ left: thumbPosition + 'px' }"
        @mousedown="startDrag"
        @touchstart="startDrag"
      ><i class="el-icon-d-arrow-right"></i></div>
    </div>

    <div class="verification-success" :class="{ show: isVerified }">
      <span class="verification-success-icon">✓</span>
      验证成功
    </div>

    <div class="button-container">
      <button class="btn btn-confirm" :disabled="!isVerified" @click="confirm">
        确定
      </button>
      <button class="btn btn-cancel" @click="reset">取消</button>
    </div>

    <div class="hint-text">
      {{ hint }}
    </div>
  </div>
</div>

</template>

<script>
export default {
  data() {
    return {
      isDragging: false,
      startX: 0,
      currentX: 0,
      sliderWidth: 0,
      thumbWidth: 40,
      isVerified: false,
      hint: "拖动滑块完成验证",
    };
  },
  computed: {
    thumbPosition() {
      // 限制滑块在轨道范围内移动
      return Math.max(
        0,
        Math.min(this.currentX, this.sliderWidth - this.thumbWidth)
      );
    },
    fillWidth() {
      return this.thumbPosition + this.thumbWidth / 2;
    },
    sliderText() {
      if (this.isVerified) {
        return "验证成功";
      }
      const progress = Math.round(
        (this.thumbPosition / (this.sliderWidth - this.thumbWidth)) * 100
      );
      return progress >= 95 ? "释放验证" : "拖动滑块";
    },
  },
  mounted() {
    this.sliderWidth = document.querySelector(".slider-container").offsetWidth;
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.sliderWidth =
        document.querySelector(".slider-container").offsetWidth;
    },
    startDrag(e) {
      e.preventDefault();
      this.isDragging = true;
      this.startX = e.type.includes("mouse") ? e.clientX : e.touches[0].clientX;

      // 添加全局事件监听
      document.addEventListener("mousemove", this.onDrag);
      document.addEventListener("mouseup", this.stopDrag);
      document.addEventListener("touchmove", this.onDrag);
      document.addEventListener("touchend", this.stopDrag);
    },
    onDrag(e) {
      if (!this.isDragging) return;

      e.preventDefault();
      const clientX = e.type.includes("mouse")
        ? e.clientX
        : e.touches[0].clientX;
      this.currentX = clientX - this.startX;

      // 检查是否验证成功（滑块到达最右侧）
      if (this.thumbPosition >= this.sliderWidth - this.thumbWidth - 5) {
        this.isVerified = true;
        this.hint = "验证成功，点击确定继续";
        this.stopDrag();
      }
    },
    stopDrag() {
      this.isDragging = false;

      // 移除全局事件监听
      document.removeEventListener("mousemove", this.onDrag);
      document.removeEventListener("mouseup", this.stopDrag);
      document.removeEventListener("touchmove", this.onDrag);
      document.removeEventListener("touchend", this.stopDrag);

      // 如果未验证成功，滑块回弹
      if (!this.isVerified) {
        this.currentX = 0;
        this.hint = "验证未完成，请继续拖动";
      }
    },
    onSliderMouseDown(e) {
      if (e.target.classList.contains("slider-thumb")) return;

      // 点击滑块轨道时，将滑块移动到点击位置
      const rect = e.currentTarget.getBoundingClientRect();
      const clickX = e.clientX - rect.left - this.thumbWidth / 2;
      this.currentX = Math.max(
        0,
        Math.min(clickX, this.sliderWidth - this.thumbWidth)
      );

      // 检查是否验证成功
      if (this.thumbPosition >= this.sliderWidth - this.thumbWidth - 5) {
        this.isVerified = true;
        this.hint = "验证成功，点击确定继续";
      } else {
        this.hint = "请继续拖动滑块完成验证";
      }
    },
    onSliderTouchStart(e) {
      if (e.target.classList.contains("slider-thumb")) return;

      // 触摸滑块轨道时，将滑块移动到触摸位置
      const rect = e.currentTarget.getBoundingClientRect();
      const touchX = e.touches[0].clientX - rect.left - this.thumbWidth / 2;
      this.currentX = Math.max(
        0,
        Math.min(touchX, this.sliderWidth - this.thumbWidth)
      );

      // 检查是否验证成功
      if (this.thumbPosition >= this.sliderWidth - this.thumbWidth - 5) {
        this.isVerified = true;
        this.hint = "验证成功，点击确定继续";
      } else {
        this.hint = "请继续拖动滑块完成验证";
      }
    },
    confirm() {
      if (this.isVerified) {
        this.hint = "验证通过！";
        // 在实际应用中，这里可以提交表单或执行其他操作
        setTimeout(() => {
           this.reset();
          this.$emit("ok")
        }, 500);
      }
    },
    reset() {
      // this.isVerified = true;
      this.$emit("close",false)
      this.isDragging = false;
      this.currentX = 0;
      this.isVerified = false;
      this.hint = "验证已重置，请重新拖动滑块";
    },
  },
};
</script>

<style scoped>
body {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
}
.boxs{
  position: absolute;
  top: 150px;
  right: 0;
  bottom: 0;
  left: 0;
  /* background: rgba(0, 0, 0, 0.5);  */
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  z-index: 999;

}
.verification-container {
  width: 100%;
  max-width: 400px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  padding: 30px;
  transition: transform 0.3s ease;
}

.verification-container:hover {
  transform: translateY(-5px);
}

.verification-title {
  text-align: center;
  color: #333;
  margin-bottom: 25px;
  font-size: 22px;
  font-weight: 600;
}

.verification-desc {
  text-align: center;
  color: #666;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 1.5;
}

.slider-container {
  position: relative;
  height: 50px;
  background-color: #f0f4f8;
  border-radius: 25px;
  margin: 30px 0;
  overflow: hidden;
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.1);
}

.slider-track {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888;
  font-size: 14px;
  font-weight: 500;
  user-select: none;
  transition: all 0.3s ease;
}

.slider-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 0;
  background: linear-gradient(90deg, #4facfe 0%, #00f2fe 100%);
  border-radius: 25px;
  transition: width 0.3s ease;
}

.slider-thumb {
  position: absolute;
  top: 5px;
  left: 5px;
  width: 40px;
  height: 40px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
  cursor: grab;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 10;
}

.slider-thumb:active {
  cursor: grabbing;
  transform: scale(1.1);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.slider-thumb::after {
  content: "";
  width: 15px;
  height: 15px;
  /* background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%234facfe"><path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 3.5C14.8 3.4 14.6 3.3 14.4 3.3C14.2 3.3 14 3.4 13.8 3.5L8 7V9C8 9.6 8.4 10 9 10H10V20C10 20.6 10.4 21 11 21H13C13.6 21 14 20.6 14 20V10H15C15.6 10 16 9.6 16 9Z"/></svg>'); */
  /* background-repeat: no-repeat; */
  /* background-position: center; */
}

.verification-success {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4caf50;
  font-weight: 600;
  margin: 10px 0;
  opacity: 0;
  transform: translateY(10px);
  transition: all 0.4s ease;
}

.verification-success.show {
  opacity: 1;
  transform: translateY(0);
}

.verification-success-icon {
  margin-right: 10px;
  font-size: 20px;
}

.button-container {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.btn {
  padding: 12px 25px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
line-height: 12px;
}

.btn-confirm {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
  box-shadow: 0 4px 10px rgba(79, 172, 254, 0.3);
}

.btn-confirm:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(79, 172, 254, 0.4);
}

.btn-cancel {
  background-color: #f0f4f8;
  color: #666;
}

.btn-cancel:hover {
  background-color: #e0e6ed;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.hint-text {
  text-align: center;
  margin-top: 15px;
  font-size: 13px;
  color: #999;
  min-height: 20px;
}

@media (max-width: 480px) {
  .verification-container {
    padding: 20px;
  }

  .button-container {
    flex-direction: column;
    gap: 15px;
  }

  .btn {
    width: 100%;
  }
}
</style>